import styles from './style.css'

class MenuTitle extends React.Component {
  render () {
    let {menuTitle, column, additionalClassName} = this.props
    let columnNumber = column === undefined ? '6' : column

    return (
      <div className={`hidden-xs hidden-sm col-md-${columnNumber} ${styles['menu-title']} ${styles[menuTitle.toLowerCase().replace(/[\W_]+/g, '-')]} ${styles[additionalClassName]}`}>
        <h2>{menuTitle}</h2>
      </div>
    )
  }
}

export default MenuTitle



// WEBPACK FOOTER //
// ./app/components/MenuTitle/MenuTitle.js